import { createElementVNode as _createElementVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start" }
const _hoisted_2 = { for: "items-per-page" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "me-1" }, "Tampilkan", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("option", { value: 5 }, "5", -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("option", { value: 10 }, "10", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("option", { value: 25 }, "25", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", { value: 50 }, "50", -1)
const _hoisted_8 = [
  _hoisted_4,
  _hoisted_5,
  _hoisted_6,
  _hoisted_7
]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "ml-1" }, "data per halaman", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("label", _hoisted_2, [
      _hoisted_3,
      (_ctx.itemsPerPageDropdownEnabled)
        ? _withDirectives((_openBlock(), _createElementBlock("select", {
            key: 0,
            class: "form-select form-select-sm form-select-solid",
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.itemsCountInTable) = $event)),
            name: "items-per-page",
            id: "items-per-page"
          }, _hoisted_8, 512)), [
            [_vModelSelect, _ctx.itemsCountInTable]
          ])
        : _createCommentVNode("", true),
      _hoisted_9
    ])
  ]))
}